import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

const Pricing = () => {
  return (
    <div>
    </div>
  )
}

export default Pricing